
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestAccount {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    CompanyId?: string;
    /**
     * 
     */
    CostName?: string;
}

/**
 * -表单校验
 */
export const DtoRequestAccountRules = {
}
